<template>
	<div class="mb-16 modalAditarItem">
		<div class="d-flex justify-start mt-7 mb-1">
			<div class="mr-16">
				<p class="mb-0"><b>Percentual máximo</b></p>
				<p class="mt-0">50%</p>
			</div>
			<div class="ml-16">
				<p class="mb-0"><b>Percentual utilizado</b></p>
				<p class="mt-0 gray--text">{{ percentualAtual + '%' }}</p>
			</div>
		</div>
		<div>
			<template>
				<v-container class="transparent mb-16 mt-0" max-width="100">
					<v-row>
						<v-col cols="12">
							<label-personalizado
								nome-campo="Percentual"
								class="mb-2"
								obrigatorio-por-padrao
							></label-personalizado>
							<v-text-field
								placeholder="Informe o %"
								variant="underlined"
								type="number"
								v-model="aditar.percentual"
								:rules="rules"
								class="ma-0 py-0"
							></v-text-field>
						</v-col>
					</v-row>
				</v-container>
			</template>
		</div>
	</div>
</template>

<script>
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'

export default {
	name: 'aditar-item',
	components: {},
	data() {
		return {
			percentualAtual: null,
			rules: [
				(valor) => !!valor || 'Percentual é obrigatório.',
				(valor) => this.naoPodeSerValorMenorOuIgualAZero(valor),
				(valor) => this.naoPodeUltrapassarLimite(valor),
			],
		}
	},
	computed: {
		...mapState({
			aditar: (state) => state.itemAta.aditamento.aditar,
		}),
	},
	mounted() {
		this.pegarPercentualAtual()
		this.aditar.idsItensAta.push(this.$store.state.itemAta.itensAtaSelecionados[0].id)
		this.aditar.idAta = this.$store.state.ata.informacoesAta.id
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.ADITAMENTO.ADITAR.RESET_PERCENTUAL)
	},
	methods: {
		naoPodeUltrapassarLimite(valorDoCampo) {
			let percentualAtual = parseFloat(this.percentualAtual) == null ? 0 : parseFloat(this.percentualAtual)
			let percentualSomado = parseFloat(valorDoCampo) + percentualAtual

			if (percentualSomado > 50) {
				return 'Percentual não pode ultrapassar de 50%.'
			}

			return true
		},
		naoPodeSerValorMenorOuIgualAZero(valorDoCampo) {
			let valorInteiro = parseFloat(valorDoCampo)

			if (valorInteiro <= 0) {
				return 'Percentual deve ser acima de 0.' //NOSONAR
			}

			return true //NOSONAR
		},
		pegarPercentualAtual() {
			if (
				this.$store.state.itemAta.itensAtaSelecionados.length > 0 &&
				this.$store.state.itemAta.itensAtaSelecionados[0].porcentagemAditar
			) {
				this.percentualAtual = this.$store.state.itemAta.itensAtaSelecionados[0].porcentagemAditar
			} else {
				this.percentualAtual = 0
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.modalAditarItem
	font-size: 15px !important;
</style>
